export const GET_ALL_CHATS = 'GET_ALL_CHATS';
export const GET_CHAT_MESSAGES = 'GET_CHAT_MESSAGES';
export const GET_NEW_MESSAGES_COUNT = 'GET_NEW_MESSAGES_COUNT';
export const SEND_MESSAGE_FILES = 'SEND_MESSAGE_FILES';
export const CREATE_CHAT = 'CREATE_CHAT';
export const START_FILES_UPLOADING = 'START_FILES_UPLOADING';
export const FINISH_FILES_UPLOADING = 'FINISH_FILES_UPLOADING';
